import { useSearchParams } from 'react-router-dom'

export type Sport = 'pickle' | 'tennis' | 'padel'
const VALID: Sport[] = ['pickle', 'tennis', 'padel']

export const SPORT_OPTIONS: { label: string; value: Sport | null }[] = [
  { label: 'All', value: null },
  { label: 'Tennis', value: 'tennis' },
  { label: 'Pickleball', value: 'pickle' },
  { label: 'Padel', value: 'padel' },
]

export const usePlayFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get('sport')
  const sport: Sport | null = raw && VALID.includes(raw as Sport) ? (raw as Sport) : null

  const setSport = (next: Sport | null) => {
    const params = new URLSearchParams(searchParams)
    if (next === null) {
      params.delete('sport')
    } else {
      params.set('sport', next)
    }
    setSearchParams(params, { replace: true })
  }

  const sportFilterCount = sport === null ? 0 : 1

  return { sport, setSport, sportFilterCount }
}
